export const Footer = ({ onOpenImpressum, onOpenDatenschutz }) => (
  <footer
    data-testid="footer"
    className="border-t border-foreground/10 bg-background"
  >
    <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-4 px-6 py-8 font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground md:flex-row md:items-center md:px-10 md:text-xs">
      <p className="flex items-center gap-3">
        <img
          src="/rundum-logo.png"
          alt="Rundum Logo"
          className="h-5 w-auto object-contain object-left"
        />
        © 2026 · Aachen
      </p>
      <p>Ehrlich. Direkt. Verlässlich.</p>
      <div className="flex items-center gap-6">
        <a
          href="/portal"
          data-testid="footer-portal-link"
          className="uppercase tracking-[0.25em] transition-colors duration-300 hover:text-primary"
        >
          Kundenportal
        </a>
        <button
          data-testid="footer-impressum-link"
          onClick={onOpenImpressum}
          className="uppercase tracking-[0.25em] transition-colors duration-300 hover:text-primary"
        >
          Impressum
        </button>
        <button
          data-testid="footer-datenschutz-link"
          onClick={onOpenDatenschutz}
          className="uppercase tracking-[0.25em] transition-colors duration-300 hover:text-primary"
        >
          Datenschutz
        </button>
        <a
          href="#start"
          data-testid="footer-top-link"
          className="transition-colors duration-300 hover:text-primary"
        >
          Nach oben ↑
        </a>
      </div>
    </div>
  </footer>
);
